<template>
  <v-container fluid>
    <vue-headful title="Logs" description="Silvester Online-Service"/>
    <v-row>
      <v-col>
        <div class="pb-3">
          <h1 class="display-1" style="color:#d30228;">Logs</h1>
        </div>
      </v-col>
    </v-row>
    <p>Sortierung: jüngste Ereignisse zuletzt</p>

    <v-row class="mx-0 mb-3" style="min-height: 40px;">
      <v-btn v-if="!loading  && current_limit <= logs.length" dark class="ml-3" @click="load_older">Ältere laden</v-btn>
      <v-btn dark class="ml-3" @click="clear_logs">Clear Logs</v-btn>
    </v-row>

    <v-progress-linear v-if="loading" class="mr-10" indeterminate></v-progress-linear>
    <v-alert type="error" v-if="error">{{reason}}</v-alert>

    <v-divider></v-divider>
    <div class="body-2">
      <span v-for="log in logs" :style="{color:log_color(log.level)}">{{log.time}} {{level_name(log.level)}} <b>{{log.logger}}</b> <pre>{{log.msg}}</pre><v-divider></v-divider></span>
    </div>
    <v-btn v-if="!loading" class="mt-3" dark @click="load_newer">Neuere laden</v-btn>
    <span ref="bottom"></span>
  </v-container>
</template>

<script>
  import {scroll_to_bottom} from "../reusable/scrolling";

  const FETCH_AMOUNT=100;
  const LIMIT_AMOUNT=200;
  export default {
    name: 'Service_Logs',
    components: {},
    data() {
      return {
        logs: [],
        loading:false,
        reason:'',
        error:false,
        offset:0,
        current_limit:LIMIT_AMOUNT, // increase to load more in bunches of 100
      }
    },
    mounted() {
      this.load();
    },
    methods: {
      load(){
        if (this.current_limit <= this.logs.length) {
          this.loading=false;
          return;
        }
        this.loading=true;
        var log_nr = this.logs.length==0 ? -1 : this.logs[0]._id;
        this.$backend.get_logs_before(log_nr, FETCH_AMOUNT, {onSuccess:this.onLoadSuccess, onError:this.onLoadError});
      },
      onLoadSuccess(data) {
        this.error=false;
        if (data.length==0) {
          this.loading = false;
          return;
        }
        var logs_length_before=this.logs.length;
        data.forEach(x=>this.logs.unshift(x));
        this.$nextTick(()=>scroll_to_bottom());
        this.load();
      },
      onLoadError(reason) {
        this.loading=false;
        this.error=true;
        this.reason=reason;
      },
      load_older() {
        this.current_limit+=LIMIT_AMOUNT;
        this.load();
      },
      load_newer() {
        this.loading=true;
        var log_nr = this.logs.length==0 ? -1 : this.logs.last()._id;
        this.$backend.get_logs_after(log_nr, FETCH_AMOUNT, {onSuccess:this.onLoadNewerSuccess, onError:this.onLoadError});
      },
      onLoadNewerSuccess(data) {
        this.error=false;
        if (data.length==0) {
          this.loading = false;
          return;
        }
        data.forEach(x=>this.logs.push(x));
        this.$nextTick(()=> scroll_to_bottom());
        this.load_newer();
      },
      clear_logs() {
        this.loading=true;
        this.$backend.clear_logs({onSuccess:()=>{
            this.offset=0;
            this.current_limit=LIMIT_AMOUNT;
            this.logs=[];
            this.load();
          }, onError:this.onLoadError});
      },
      level_name(lvl) {
        switch (lvl) {
          case 3: return "DEBUG";
          case 4: return "INFO";
          case 6: return "WARN";
          case 7: return "ERROR";
          case 11: return "FATAL";
          default: return "UNKNOWN";
        }
      },
      log_color(lvl) {
        switch (lvl) {
          case 3: return "#999";
          case 4: return "#000";
          case 6: return "orange";
          case 7: return "red";
          case 11: return "darkred";
          default: return "#000";
        }
      }
    },
    computed: {
    },
    watch: {
      // settings_edited: {
      //     deep:true,
      //     handler(o, n) {
      //         this.changed= JSON.stringify(this.settings)!==JSON.stringify(this.settings_edited);
      //     }
      // }
    }
  }
</script>
